import { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import { details } from '../../routes/routes';
import { DetailsSearchParams } from './use-details-search-params';
import { DetailsParams } from './utils';

interface DetailsLinkProps extends DetailsParams, Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'id' | 'type'> {
  children: React.ReactNode;
  params?: Partial<DetailsSearchParams>;
  className?: string;
}

export const DetailsLink = forwardRef<HTMLAnchorElement, DetailsLinkProps>(
  ({ id, type, subType, children, className, params, ...rest }, ref) => {
    return (
      <Link to={details.path({ id, type, subType, params })} className={className} ref={ref} {...rest}>
        {children}
      </Link>
    );
  },
);
